import { useState } from "react";
import { airports } from "../assets/jsons/airports_translated";
import {InputField} from "./Quotation";

const AirportAutocompleteField = ({ id, label, placeholder, icon, value, onChange, lang = "fr" }) => {
    const [filtered, setFiltered] = useState([]);
    const [showList, setShowList] = useState(false);

    const handleInputChange = (e) => {
        const input = e.target.value;
        onChange({ target: { id, value: input } });

        if (input.length > 1) {
            const results = airports.filter((airport) =>
                airport.translations[lang].toLowerCase().includes(input.toLowerCase()) ||
                airport.city[lang].toLowerCase().includes(input.toLowerCase()) ||
                airport.iata.toLowerCase().includes(input.toLowerCase())
            );
            setFiltered(results.slice(0, 5));
            setShowList(true);
        } else {
            setFiltered([]);
            setShowList(false);
        }
    };

    const handleSelect = (airport) => {
        const label = `${airport.translations[lang]} (${airport.iata})`;
        onChange({ target: { id, value: label } });
        setFiltered([]);
        setShowList(false);
    };

    return (
        <div className="relative">
            <InputField
                icon={icon}
                id={id}
                label={label}
                placeholder={placeholder}
                value={value}
                onChange={handleInputChange}
                autoComplete="off"
                required
            />
            {showList && filtered.length > 0 && (
                <ul className="absolute z-10 w-full bg-white border rounded shadow max-h-96 overflow-auto">
                    {filtered.map((airport, index) => (
                        <li
                            key={index}
                            onClick={() => handleSelect(airport)}
                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-black"
                        >
                            {airport.translations[lang]} ({airport.iata}) – {airport.city[lang]}, {airport.country[lang]}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AirportAutocompleteField;
